import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { HotelsResultResponse } from 'models/hotelsSearch';
import { getFormattedPrice } from 'utils/currency';

import { Price } from './styles';

interface Props {
  lat: number;
  lng: number;
  zoom: number;
  itemCode: number;
  onSelect: (key: number) => void;
  isSelected: boolean;
  data: HotelsResultResponse;
}

const MapPin = ({ data, zoom, itemCode, onSelect, isSelected }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency: data.currencyCode, t });
    return formatted;
  };

  return (
    <Price isSelected={isSelected} onClick={() => onSelect(itemCode)} zoom={zoom}>
      {formattedPrice(data.priceFrom)}
    </Price>
  );
};

export default MapPin;
